const newTask = {
  titles: {
    onetime: "Onetime Task Profile",
    recurrent: "Recurrent Task Profile"
  },
  labels: {
    tag: "Asset Tag",
    alertTime: "Alert Time",
    lifetime: "Lifetime",
    name: "Task Name",
    description: "Description",
    type: "Task Type",
    due: "Due Date",
    subtypes: {
      maintenance: "maintenance",
      repair: "repair",
      reliability: "reliability"
    }
  },
  headers: {
    notificationFrequency: "Notification Frequency",
    taskFrequency: "Task Frequency"
  },
  buttons: {
    ok: "OK",
    cancel: "CANCEL",
    submit: "SUBMIT",
    back: "Go Back",
    gotoTaskProfile: "Go to task's profile",
    gotoCreateTask: "Create another task",
    gotoPlanner: "Go back to Planner"
  },
  messages: {
    notificationFrequency:
      "Corresponds to the period of time in which this task must be repeated",
    taskFrequency:
      "Corresponds to the period of time in which this task must be notified, this time must be less than the frequency of the task",
    finaltext: "The alert time have to be less than the lifetime"
  },
  date: {
    day: "day",
    week: "week",
    month: "month",
    year: "year"
  }
};
export default newTask;
